'use strict';

var closeAccountDrawerTimeout;

var keyboardAccessibility = require('base/components/keyboardAccessibility');

var clearSelection = function (element) {
	$(element).closest('.dropdown').children('.dropdown-menu').children('.top-category')
		.detach();
	$(element).closest('.dropdown.show').children('.nav-link').attr('aria-expanded', 'false');
	$(element).closest('.dropdown.show').children('.dropdown-menu').attr('aria-hidden', 'true');
	$(element).closest('.dropdown.show').removeClass('show');
	$('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'false');
	$(element).closest('li').detach();
};

var navCollisionDetection = function (element) {
	var screenWidth = window.innerWidth;
	var navItemXPos = Math.ceil($(element).offset().left);

	if ($(element).hasClass('dropdown')) {
		var dropdownItem = $(element).children('.dropdown-menu');
	} else {
		var dropdownItem = $(element).closest('.dropdown').children('.dropdown-menu');
	}
	var dropdownItemWidth = Math.ceil(dropdownItem.outerWidth());

	if (navItemXPos + dropdownItemWidth > screenWidth && !dropdownItem.hasClass('collided')) {
		dropdownItem.addClass('collided');
	} else if (navItemXPos + dropdownItemWidth <= screenWidth && dropdownItem.hasClass('collided')) {
		dropdownItem.removeClass('collided');
	}
}

module.exports = function () {
	var isDesktop = function (element) {
		return $(element).parents('.menu-toggleable-left').css('position') !== 'fixed';
	};

	$('.navbar-menu-toggle').on('click', function () {
		$('.mobile-nav-wrapper').toggleClass('hidden');
	});

	var headerBannerStatus = window.sessionStorage.getItem('hide_header_banner');
	$('.header-banner .close').on('click', function () {
		$('.header-banner').addClass('d-none');
		window.sessionStorage.setItem('hide_header_banner', '1');
	});

	if (!headerBannerStatus || headerBannerStatus < 0) {
		$('.header-banner').removeClass('d-none');
	}

	keyboardAccessibility('.main-menu .nav-link, .main-menu .dropdown-link',
		{
			40: function (menuItem) { // down
				if (menuItem.hasClass('nav-item')) { // top level
					$('.navbar-nav .show').removeClass('show')
						.children('.dropdown-menu')
						.removeClass('show');
					navCollisionDetection(menuItem);
					menuItem.addClass('show').children('.dropdown-menu').addClass('show');
					menuItem.find('ul > li > a')
						.first()
						.focus();
				} else {
					menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
					if (!(menuItem.next().length > 0)) { // if this is the last menuItem
						menuItem.parent().parent().find('li > a') // set focus to the first menuitem
							.first()
							.focus();
					} else {
						menuItem.next().children().first().focus();
					}
				}
			},
			39: function (menuItem) { // right
				if (menuItem.hasClass('nav-item')) { // top level
					menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
					$(this).attr('aria-expanded', 'false');
					menuItem.next().children().first().focus();
				} else if (menuItem.hasClass('dropdown')) {
					menuItem.addClass('show').children('.dropdown-menu').addClass('show');
					$(this).attr('aria-expanded', 'true');
					menuItem.find('ul > li > a')
						.first()
						.focus();
				}
			},
			38: function (menuItem) { // up
				if (menuItem.hasClass('nav-item')) { // top level
					menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
				} else if (menuItem.prev().length === 0) { // first menuItem
					menuItem.parent().parent().removeClass('show')
						.children('.nav-link')
						.attr('aria-expanded', 'false');
					menuItem.parent().children().last().children() // set the focus to the last menuItem
						.first()
						.focus();
				} else {
					menuItem.prev().children().first().focus();
				}
			},
			37: function (menuItem) { // left
				if (menuItem.hasClass('nav-item')) { // top level
					menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
					$(this).attr('aria-expanded', 'false');
					menuItem.prev().children().first().focus();
				} else {
					menuItem.closest('.show').removeClass('show')
						.closest('li.show').removeClass('show')
						.children()
						.first()
						.focus()
						.attr('aria-expanded', 'false');
				}
			},
			27: function (menuItem) { // escape
				var parentMenu = menuItem.hasClass('show')
					? menuItem
					: menuItem.closest('li.show');
				parentMenu.children('.show').removeClass('show');
				parentMenu.removeClass('show').children('.nav-link')
					.attr('aria-expanded', 'false');
				parentMenu.children().first().focus();
			}
		},
		function () {
			return $(this).parent();
		}
	);

	$('.dropdown:not(.disabled) [data-toggle="dropdown"]')
		.on('click', function (e) {
			if (!isDesktop(this)) {
				$('.modal-background').show();
				// copy parent element into current UL
				var li = $('<li class="dropdown-item top-category" role="button"></li>');
				var link = $(this).clone().removeClass('dropdown-toggle')
					.removeAttr('data-toggle')
					.removeAttr('aria-expanded')
					.attr('aria-haspopup', 'false');
				li.append(link);
				var closeMenu = $('<li class="nav-menu"></li>');
				closeMenu.append($('.back.menu-navigation').clone());
				$(this).parent().children('.dropdown-menu')
					.prepend(li)
					.prepend(closeMenu)
					.attr('aria-hidden', 'false');
				// copy navigation menu into view
				$(this).parent().addClass('show');
				$(this).attr('aria-expanded', 'true');
				$(link).focus();
				$('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'true');
				e.preventDefault();
			}
		})
		.on('mouseenter', function () {
			if (isDesktop(this)) {
				var eventElement = this;
				$('.navbar-nav > li').each(function () {
					if (!$.contains(this, eventElement)) {
						$(this).find('.show').each(function () {
							clearSelection(this);
						});
						if ($(this).hasClass('show')) {
							$(this).removeClass('show');
							$(this).children('ul.dropdown-menu').removeClass('show');
							$(this).children('.nav-link').attr('aria-expanded', 'false');
						}
					}
				});
				// need to close all the dropdowns that are not direct parent of current dropdown
				navCollisionDetection(this);
				$(this).parent().addClass('show');
				$(this).siblings('.dropdown-menu').addClass('show');
				$(this).attr('aria-expanded', 'true');
			}
		})
		.parent()
		.on('mouseleave', function () {
			if (isDesktop(this)) {
				$(this).removeClass('show');
				$(this).children('.dropdown-menu').removeClass('show');
				$(this).children('.nav-link').attr('aria-expanded', 'false');
			}
		});

	$('.navbar>.close-button.menu-navigation').on('click', function (e) {
		e.preventDefault();
		$('.menu-toggleable-left').removeClass('in');
		$('.modal-background').hide();

		$('.navbar-toggler').focus();

		$('.main-menu').attr('aria-hidden', 'true');
		$('.main-menu').siblings().attr('aria-hidden', 'false');
		$('header').siblings().attr('aria-hidden', 'false');
	});

	$('.navbar-nav').on('click', '.back', function (e) {
		e.preventDefault();
		clearSelection(this);
	});

	$('.navbar-nav').on('click', '.close-button', function (e) {
		e.preventDefault();
		$('.navbar-nav').find('.top-category').detach();
		$('.navbar-nav').find('.nav-menu').detach();
		$('.navbar-nav').find('.show').removeClass('show');
		$('.menu-toggleable-left').removeClass('in');

		$('.main-menu').siblings().attr('aria-hidden', 'false');
		$('header').siblings().attr('aria-hidden', 'false');

		$('.modal-background').hide();
	});

	$('.navbar-toggler').click(function (e) {
		e.preventDefault();
		$('.main-menu').toggleClass('in');
		$('.modal-background').show();

		$('.main-menu').removeClass('d-none');
		$('.main-menu').attr('aria-hidden', 'false');
		$('.main-menu').siblings().attr('aria-hidden', 'true');
		$('header').siblings().attr('aria-hidden', 'true');

		$('.main-menu .nav.navbar-nav .nav-link').first().focus();
	});

	//Drawer - open
	$('body').on('click mouseenter focusin', '.drawer-toggle', function (event) {
		event.preventDefault();
		var e = {};

		if ($('.modal-background').length > 0) {
			var modalBackground = $('.modal-background');
		} else {
			$('body').append('<div class="modal-background" style="display: none;"></div>');
			var modalBackground = $('.modal-background');
		}

		var drawer = $(this).closest('.drawer');
		var drawerMenu = drawer.find('.drawer-menu').first();

		if (drawerMenu.css('position') == 'fixed') {
			modalBackground.show();
		} else {
			$('body').on('mouseover', '.drawer-menu', { drawer: drawer, drawerMenu: drawerMenu }, showAccountMenu);
		}
		e.data = { drawer: drawer, drawerMenu: drawerMenu };
		showAccountMenu(e);
	});

	function showAccountMenu(e) {
		clearTimeout(closeAccountDrawerTimeout);
		e.data.drawer.addClass('drawer-active');
		e.data.drawerMenu.addClass('show');
	}

	//Drawer - mobile close
	$('body').on('click', '.drawer-close-js', function (event) {
		event.preventDefault();
		$('body').off('mouseover', '.drawer-menu', showAccountMenu);

		var drawer = $(this).closest('.drawer');
		var drawerMenu = drawer.find('.drawer-menu').first();

		if (drawer.hasClass('drawer-active')) {
			if ($('.modal-background'.length > 0)) {
				$('.modal-background').hide();
			}

			drawer.removeClass('drawer-active');
			drawerMenu.removeClass('show');
		}
	});

	//Drawer - desktop close
	$('body').on('mouseleave', '.drawer-active', function () {
		var drawer = $(this);
		var drawerMenu = drawer.find('.drawer-menu').first();
		if (drawer.hasClass('drawer-active') && drawerMenu.css('position') !== 'fixed') {
			closeAccountDrawerTimeout = setTimeout(function () {
				drawerMenu.fadeOut(400, function () {
					drawerMenu.removeClass('show');
					drawerMenu.css('display', '');
					drawer.removeClass('drawer-active');
				});
				$('body').off('mouseover', '.drawer-menu', showAccountMenu);
			}, 1000);
		}
	});

	$('body').on('click', '.drawer-close-donation-js', function (event) {
		event.preventDefault();
		$('.cart-donate-menu').slideUp(800);
		var expirationDate = new Date();
		expirationDate.setHours(expirationDate.getHours() + 24);
		document.cookie = "donationModal=true; expires=" + expirationDate.toUTCString() + "; path=/";
	});
};
